import { useQuery, useQueryClient } from "@tanstack/react-query"
import { dropdownCuentaContableAdapterModalAsiento } from "common/components/DropdownsCuentasContables/dropdownCuentaContable.adapter"
import {
  CuentaContableEmpresaByFilterParamsProps,
  getCuentaContableByFilter,
  getEntidadCuentaContableEmpresa,
} from "./CuentaContableEmpresa.service"
import {
  CATEGORIA_CUENTA_CONTABLE_ENUM,
  CategoriaCuentaContableEnumType,
} from "./Types/CategoriaCuentaContableEnum"

const generarHookParaEntidad = (entidad?: CategoriaCuentaContableEnumType) => {
  return () => {
    const {
      data: cuentasContablesEmpresas,
      isLoading: cuentasContablesEmpresasIsLoading,
      error: cuentasContablesEmpresasError,
      refetch: cuentasContablesEmpresasRefetch,
    } = useQuery({
      queryKey: ["cuentasContablesEmpresas", entidad],
      queryFn: () => getEntidadCuentaContableEmpresa(entidad),
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 20,
      retry: false,
    })

    return {
      cuentasContablesEmpresas,
      cuentasContablesEmpresasIsLoading,
      cuentasContablesEmpresasError,
      cuentasContablesEmpresasRefetch,
    }
  }
}

export const useCuentaContableEmpresaAll = generarHookParaEntidad()
export const useCuentaContableEmpresaOtro = generarHookParaEntidad(
  CATEGORIA_CUENTA_CONTABLE_ENUM.OTRO
)
export const useCuentaContableEmpresaCliente = generarHookParaEntidad(
  CATEGORIA_CUENTA_CONTABLE_ENUM.CLIENTE
)
export const useCuentaContableEmpresaProveedor = generarHookParaEntidad(
  CATEGORIA_CUENTA_CONTABLE_ENUM.PROVEEDOR
)
export const useCuentaContableEmpresaCompra = generarHookParaEntidad(
  CATEGORIA_CUENTA_CONTABLE_ENUM.COMPRA
)
export const useCuentaContableEmpresaVenta = generarHookParaEntidad(
  CATEGORIA_CUENTA_CONTABLE_ENUM.VENTA
)
export const useCuentaContableEmpresaPrestamoConcedido = generarHookParaEntidad(
  CATEGORIA_CUENTA_CONTABLE_ENUM.PRESTAMO_CONCEDIDO
)
export const useCuentaContableEmpresaPrestamoRecibido = generarHookParaEntidad(
  CATEGORIA_CUENTA_CONTABLE_ENUM.PRESTAMO_RECIBIDO
)
export const useCuentaContableEmpresaInteresPrestamoConcedido =
  generarHookParaEntidad(
    CATEGORIA_CUENTA_CONTABLE_ENUM.INTERES_PRESTAMO_CONCEDIDO
  )
export const useCuentaContableEmpresaInteresPrestamoRecibido =
  generarHookParaEntidad(
    CATEGORIA_CUENTA_CONTABLE_ENUM.INTERES_PRESTAMO_RECIBIDO
  )
export const useCuentaContableEmpresaIvaCompra = generarHookParaEntidad(
  CATEGORIA_CUENTA_CONTABLE_ENUM.IVA_COMPRA
)
export const useCuentaContableEmpresaIvaVenta = generarHookParaEntidad(
  CATEGORIA_CUENTA_CONTABLE_ENUM.IVA_VENTA
)
export const useCuentaContableEmpresaRetencionCompra = generarHookParaEntidad(
  CATEGORIA_CUENTA_CONTABLE_ENUM.RETENCION_COMPRA
)
export const useCuentaContableEmpresaRetencionVenta = generarHookParaEntidad(
  CATEGORIA_CUENTA_CONTABLE_ENUM.RETENCION_VENTA
)
export const useCuentaContableEmpresaCuentaBancaria = generarHookParaEntidad(
  CATEGORIA_CUENTA_CONTABLE_ENUM.CUENTA_BANCARIA
)
export const useCuentaContableEmpresaComisionAperturaPrestamoConcedido =
  generarHookParaEntidad(
    CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_APERTURA_PRESTAMO_CONCEDIDO
  )
export const useCuentaContableEmpresaComisionAperturaPrestamoRecibido =
  generarHookParaEntidad(
    CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_APERTURA_PRESTAMO_RECIBIDO
  )
export const useCuentaContableEmpresaComisionCorretajePrestamoConcedido =
  generarHookParaEntidad(
    CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_CORRETAJE_PRESTAMO_CONCEDIDO
  )
export const useCuentaContableEmpresaComisionCorretajePrestamoRecibido =
  generarHookParaEntidad(
    CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_CORRETAJE_PRESTAMO_RECIBIDO
  )
export const useCuentaContableEmpresaComisionDisposicionPrestamoConcedido =
  generarHookParaEntidad(
    CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_DISPOSICION_PRESTAMO_CONCEDIDO
  )
export const useCuentaContableEmpresaComisionDisposicionPrestamoRecibido =
  generarHookParaEntidad(
    CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_DISPOSICION_PRESTAMO_RECIBIDO
  )
export const useCuentaContableEmpresaComisionEstudioPrestamoConcedido =
  generarHookParaEntidad(
    CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_ESTUDIO_PRESTAMO_CONCEDIDO
  )
export const useCuentaContableEmpresaComisionEstudioPrestamoRecibido =
  generarHookParaEntidad(
    CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_ESTUDIO_PRESTAMO_RECIBIDO
  )
export const useCuentaContableEmpresaComisionOtraPrestamoRecibido =
  generarHookParaEntidad(
    CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_OTRA_PRESTAMO_RECIBIDO
  )
export const useCuentaContableEmpresaComisionOtraPrestamoConcedido =
  generarHookParaEntidad(
    CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_OTRA_PRESTAMO_CONCEDIDO
  )
export const useCuentaContableEmpresaActivo = generarHookParaEntidad(
  CATEGORIA_CUENTA_CONTABLE_ENUM.ACTIVO
)
export const useCuentaContableEmpresaActivoContrapartida =
  generarHookParaEntidad(CATEGORIA_CUENTA_CONTABLE_ENUM.ACTIVO_CONTRAPARTIDA)
export const useCuentaContableEmpresaActivoAmortizacionAcumulada =
  generarHookParaEntidad(
    CATEGORIA_CUENTA_CONTABLE_ENUM.ACTIVO_AMORTIZACION_ACUMULADA
  )
export const useCuentaContableEmpresaActivoAmortizacionGastos =
  generarHookParaEntidad(
    CATEGORIA_CUENTA_CONTABLE_ENUM.ACTIVO_AMORTIZACION_GASTOS
  )

export const useCuentaContableEmpresaTicketReembolso = generarHookParaEntidad(
  CATEGORIA_CUENTA_CONTABLE_ENUM.TICKET_REEMBOLSO
)

/**
 * Custom hook to fetch cuenta contable empresa data by filter.
 * @param queryParams - Optional query parameters for filtering the data.
 * @returns An object containing cuenta contable empresa data, loading state, error state, and utility functions.
 */
export function useGetCuentaContableByFilter(
  queryParams?: CuentaContableEmpresaByFilterParamsProps
) {
  const queryClient = useQueryClient()
  const {
    data: cuentasContablesEmpresa,
    isLoading: cuentasContablesEmpresaIsLoading,
    error: cuentasContablesEmpresaError,
    refetch: cuentasContablesEmpresaRefetch,
  } = useQuery({
    queryKey: ["getUsuarioEmpresaActiva", queryParams],
    queryFn: () => getCuentaContableByFilter(queryParams),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60 * 2, // 2 hours
    retry: false,
  })

  const cuentasContablesEmpresaInvalidation = () =>
    queryClient.invalidateQueries({ queryKey: ["getUsuarioEmpresaActiva"] })

  return {
    cuentasContablesEmpresa,
    cuentasContablesEmpresaIsLoading,
    cuentasContablesEmpresaError,
    cuentasContablesEmpresaRefetch,
    cuentasContablesEmpresaInvalidation,
  }
}

const generarHookParaEntidadModalAsientos = (
  entidad?: CategoriaCuentaContableEnumType
) => {
  return () => {
    const {
      data: cuentasContablesEmpresas,
      isLoading: cuentasContablesEmpresasIsLoading,
      error: cuentasContablesEmpresasError,
      refetch: cuentasContablesEmpresasRefetch,
    } = useQuery({
      queryKey: ["cuentasContablesEmpresas", entidad, "adaptada"],
      queryFn: async () => {
        const cuentas = await getEntidadCuentaContableEmpresa(entidad)
        return dropdownCuentaContableAdapterModalAsiento(cuentas)
      },
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 20,
      retry: false,
    })
    return {
      cuentasContablesEmpresas,
      cuentasContablesEmpresasIsLoading,
      cuentasContablesEmpresasError,
      cuentasContablesEmpresasRefetch,
    }
  }
}

export const useCuentaContableEmpresaAllModalAsiento =
  generarHookParaEntidadModalAsientos()
export const useCuentaContableEmpresaIvaCompraModalAsientos =
  generarHookParaEntidadModalAsientos(CATEGORIA_CUENTA_CONTABLE_ENUM.IVA_COMPRA)
export const useCuentaContableEmpresaIvaVentaModalAsiento =
  generarHookParaEntidadModalAsientos(CATEGORIA_CUENTA_CONTABLE_ENUM.IVA_VENTA)
